import { useState } from "react";
import { Link } from "react-router";
import logo from "../../assets/logo.png";
import { Gradient } from "../Gradient";
import { Text } from "../tailwind/text";
import { SignUpForm } from "./SignUpForm";

export const InvitationPage = ({
  setShowSignUp,
  handleSignUp,
  isLoading,
  invitationCode,
  companyName,
}) => {
  const [companyCode, setCompanyCode] = useState(invitationCode);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [phone, setPhone] = useState("");
  const [errors, setErrors] = useState({ email: "", password: "" });

  // États pour le formulaire de compte existant
  const [existingEmail, setExistingEmail] = useState("");
  const [existingPassword, setExistingPassword] = useState("");
  const [existingErrors, setExistingErrors] = useState({
    email: "",
    password: "",
  });

  const validate = () => {
    const newErrors = {
      email: "",
      password: "",
      companyCode: "",
      firstName: "",
      lastName: "",
    };
    if (!email) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = "Email address is invalid";
    }
    if (!password) {
      newErrors.password = "Password is required";
    } else if (password.length < 8) {
      newErrors.password = "Password must be at least 8 characters";
    }
    if (!companyCode) {
      newErrors.companyCode = "Company Invitation Code is required";
    }
    if (!firstName) {
      newErrors.firstName = "First Name is required";
    }
    if (!lastName) {
      newErrors.lastName = "Last Name is required";
    }

    setErrors(newErrors);
    return (
      !newErrors.email &&
      !newErrors.password &&
      !newErrors.companyCode &&
      !newErrors.firstName &&
      !newErrors.lastName
    );
  };

  const validateExisting = () => {
    const newErrors = {
      email: "",
      password: "",
      companyCode: "",
    };
    if (!existingEmail) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(existingEmail)) {
      newErrors.email = "Email address is invalid";
    }
    if (!existingPassword) {
      newErrors.password = "Password is required";
    }
    if (!companyCode) {
      newErrors.companyCode = "Company Invitation Code is required";
    }
    setExistingErrors(newErrors);
    return !newErrors.email && !newErrors.password && !newErrors.companyCode;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      handleSignUp(
        {
          firstName: firstName.trim(),
          lastName: lastName.trim(),
          email: email.toLowerCase().trim(),
          password,
          phone,
        },
        companyCode,
      );
    }
  };

  const handleExistingSubmit = (e) => {
    e.preventDefault();
    if (validateExisting()) {
      handleSignUp(
        {
          email: existingEmail.toLowerCase().trim(),
          password: existingPassword,
          multiAccount: true,
        },
        companyCode,
      );
    }
  };

  const [checked, setChecked] = useState(false);
  const [existingChecked, setExistingChecked] = useState(false);

  const onChange = (e) => {
    setChecked(e.target.checked);
  };

  const onExistingChange = (e) => {
    setExistingChecked(e.target.checked);
  };

  return (
    <Gradient>
      <div className="flex min-h-full flex-1 flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <img className="mx-auto h-10 w-auto" src={logo} alt="Simio" />
          <h2 className="mt-6 text-center text-2xl font-bold font-title leading-9 tracking-tight text-gray-900">
            {companyName
              ? "Welcome to Simio's new interface 🎉"
              : "You've been invited to Simio"}
          </h2>
          {companyName && (
            <Text className="text-center">
              Complete this form and you will be connected to {companyName}'s
              account
            </Text>
          )}
        </div>

        <div className="mt-2 sm:mx-auto sm:w-full sm:max-w-[960px] z-20">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* Formulaire pour nouveau compte */}
            <div className="bg-white px-6 py-5 shadow sm:rounded-lg">
              <h3 className="text-lg font-semibold text-gray-900 mb-4 text-center">
                Create a new account
              </h3>
              <p className="text-sm text-gray-600 mb-4 text-center">
                If you don't already have a Simio account.
              </p>
              <SignUpForm
                companyCode={companyCode}
                setCompanyCode={setCompanyCode}
                firstName={firstName}
                setFirstName={setFirstName}
                lastName={lastName}
                setLastName={setLastName}
                email={email}
                setEmail={setEmail}
                password={password}
                setPassword={setPassword}
                phone={phone}
                setPhone={setPhone}
                errors={errors}
                checked={checked}
                onChange={onChange}
                handleSubmit={handleSubmit}
                isLoading={isLoading}
              />
            </div>

            {/* Formulaire pour compte existant */}
            <div className="bg-white px-6 py-5 shadow sm:rounded-lg">
              <h3 className="text-lg font-semibold text-gray-900 mb-4 text-center">
                Sign in to an existing account
              </h3>
              <p className="text-sm text-gray-600 mb-4 text-center">
                If you already have a Simio account.
              </p>
              <SignUpForm
                companyCode={companyCode}
                setCompanyCode={setCompanyCode}
                email={existingEmail}
                setEmail={setExistingEmail}
                password={existingPassword}
                setPassword={setExistingPassword}
                errors={existingErrors}
                checked={existingChecked}
                onChange={onExistingChange}
                handleSubmit={handleExistingSubmit}
                isLoading={isLoading}
                hideNameFields={true}
                buttonText="Log In"
              />
            </div>
          </div>

          <Text className="mt-10 text-center">
            Already a member?{" "}
            <Link
              onClick={() => setShowSignUp(false)}
              className="font-semibold text-purple hover:text-purple/80"
            >
              Sign in instead
            </Link>
          </Text>
        </div>
      </div>
    </Gradient>
  );
};
